module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/codepipeline-2015-07-09.paginators.json
// module id = 321
// module chunks = 1